import { useContentCache, useUserStore } from "@/entities"
import {
	authControllerApplyPromoCode,
	type ApplyPromoCodeDto,
} from "@/shared/api/generated"
import { useMutation } from "@tanstack/react-query"
import type { AxiosError } from "axios"
import { useState } from "react"
import { useForm } from "react-hook-form"

type FormData = ApplyPromoCodeDto
export function useApplyPromoCodeForm() {
	const login = useUserStore(s => s.login)
	const contentCache = useContentCache()
	const [isLoading, setIsLoading] = useState(false)
	const [formError, setFormError] = useState("")

	const { control, handleSubmit, reset, watch } = useForm<FormData>({
		defaultValues: {
			code: "",
		},
	})

	const formMutation = useMutation({
		mutationFn: (data: ApplyPromoCodeDto) => authControllerApplyPromoCode(data),
		async onSuccess({ access_token }) {
			await login(access_token)
			await contentCache.invalidateLibraryActivePage()
			reset()
			setIsLoading(false)
			setFormError("")
		},
		onError: (e: AxiosError<{ message: string }>) => {
			setFormError(e.response?.data.message ?? "")
			setIsLoading(false)
		},
	})

	const codeValue = watch("code")

	return {
		handleSubmit: handleSubmit(values => {
			setFormError("")
			if (!values.code.trim()) {
				setFormError("Promo code is required")
				return
			}
			setIsLoading(true)
			formMutation.mutate(values)
		}),
		isLoading,
		codeValue,
		control,
		formError,
	}
}
